import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pushPageViewEvent } from "../utilities/gtm";
import { ApplicationStateContext } from "../contexts";

/** Make a page title for the GA event.
 */
const pageTitle = (path) => {
  if (path.includes("global-testing")) {
    return "Global Testing";
  }
  if (path.includes("global-tests")) {
    return "Global Test Results";
  }
  if (path.includes("detail-testing")) {
    return "Detail Testing";
  }
  if (path.includes("detail-test")) {
    return "Detail Test Results";
  }

  return "Home";
};

/** Determine if we should note this page view.
 *
 */
const shouldReport = (path, ads) => {
  // A testing page with no ads.
  if (path.includes("testing") && !ads) {
    return true;
  }

  // Not a testing page.
  if (!path.includes("testing")) {
    return true;
  }

  return false;
};

/** Make a page path for the GA event. Just uses the window location.
 */
const pagePath = () => {
  return window.location.pathname;
};

export const PageTracking = (props) => {
  let location = useLocation();
  const { applicationState } = useContext(ApplicationStateContext);

  useEffect(() => {
    if (shouldReport(location.pathname.toLowerCase(), applicationState?.loadedAds ?? true)) {
      pushPageViewEvent(pagePath(), pageTitle(location.pathname.toLowerCase()));
    }
  }, [location]);

  return props.children;
};
